import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Spinner, EmptyState } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { History } from "lucide-react";

export default function ReceivingHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/receiving").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader title="Receiving History" subtitle="Riwayat receiving yang Anda buat." />
      {loading ? <Spinner /> : rows.length === 0 ? <EmptyState title="Belum ada receiving" icon={History} /> : (
        <div className="grid gap-2">
          {rows.map((r) => (
            <Card key={r.id} className="p-3 flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="font-mono-data font-semibold text-gray-900">{r.nopol || "—"}</div>
                <div className="text-sm text-gray-600 truncate">{(r.items || []).map((i) => `${i.part_number} ×${i.qty}`).join(", ")}</div>
                <div className="text-xs text-gray-400 mt-0.5">{r.receiving_number || "no-rcv"} • {new Date(r.created_at).toLocaleString("id-ID")}</div>
              </div>
              <StatusBadge status={r.match_status} />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
